import styled from 'styled-components';

const Button = styled.button`
  display: inline-block;
  padding: 0px 10px;
  margin-right: 20px;
  border-radius: 30px;
  -webkit-font-smoothing: antialiased;
  -webkit-touch-callout: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  white-space: nowrap;
  background: ${props => props.active ? "#EBEFF3" : "transparent"};
  color: #fff;
  transition: 0.3s;
  border: 1px solid #fff;
  &:hover {
    opacity: 1;
  }
  &:focus {
    outline: 0px;
  }
`;

export default Button;
